import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {formatDate, exportCSV} from "../../utils/helper";
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import google from '../../assets/images/google.png'; 
import apple from '../../assets/images/apple.webp'; 
import email_user from '../../assets/images/user-email.webp'; 
import guest_user from '../../assets/images/guest-user.webp'; 
import { selectStoredPermissions } from '../../stores/permissionsSlice';


const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [users, setUsers] = useState([]);
    const [pagination, setPagination] = useState({});

    
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const type = searchParams.get('type') ?? "email";

    
    const [apiData, setApiData] = useState({
        search: searchParams.get('search') || "",
        daterange: searchParams.get('daterange') ? 
            JSON.parse(searchParams.get('daterange')) : [],
        page: parseInt(searchParams.get('page')) || 1,
        type: searchParams.get('type') ?? "email",
        is_export: searchParams.get('is_export') || false
    });
    const [counts, setCounts] = useState([]);

    

    // Update URL when filters change
    useEffect(() => {
        const params = new URLSearchParams();
        if (apiData.search) params.set('search', apiData.search);
        if (apiData.daterange && apiData.daterange.length > 0) params.set('daterange', JSON.stringify(apiData.daterange));
        if (apiData.page > 1) params.set('page', apiData.page.toString());
        if (apiData.type) params.set('type', apiData.type);
        if (apiData.is_export) params.set('is_export', apiData.is_export);

        navigate(`?${params.toString()}`, { replace: true });
    }, [apiData.search, apiData.daterange, apiData.page, apiData.type, apiData.is_export, navigate]);

    
    useEffect(() => {
        getUsers();
    }, [apiData.page, apiData.search, apiData.daterange,  apiData.type, type, apiData.is_export]); // Dependency array for re-fetching data

    const getUsers = async () => {
        try {
            apiData.type= type;
            if(apiData.is_export) {
                setIsExporting(true);
            } else {
                setIsLoader(true);
            }

            const response = await ApiService.request({
                method: "GET",
                url: "users", // Replace with your API endpoint
                data: apiData
            });
            const data = response.data;

            if(apiData.is_export){
                exportData(data.data);
                setApiData({...apiData, is_export:false});
                setIsLoader(false);
                setIsExporting(false);
                return 0;
            }

            if (data.status) {
                setUsers(data.data);
                setCounts(data.counts);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
            setIsExporting(false);
        } catch (error) {
            setIsLoader(false);
            setIsExporting(false);
        }
       
    };


    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: [],
            page: 1,
            type: type
        });
    };

    const exportData = (data) => {
        const columnsMap = {
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            status: 'Status',
            createdAt: 'Created Date',
        };
        const processedData = data.map(item => {
            const newItem = {};
            Object.keys(columnsMap).forEach(key => {
                let value = item[key];
                if (key === 'status') {
                    value = value ? 'Active' : 'Inactive';
                }
                if (key === 'createdAt') {
                    value = formatDate(value);
                }
                newItem[key] = value !== undefined ? value : '';
            });
            return newItem;
        });

        exportCSV(processedData, columnsMap, 'users_data');
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `users/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getUsers();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

 

    const updateStatus = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "you want to change its status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `users/status/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getUsers();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Customers</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Customers</li>
                        </ul>
                    </div>
                    <div className="d-flex align-users-center gap-2 gap-lg-3">
                        {/* Add New users Button */}
                         <button type="button" disabled={isExporting} onClick={()=> setApiData({...apiData, is_export:true})}  className='btn btn-secondary btn-sm'> 
                             {isExporting && <span className="spinner-border spinner-border-sm align-middle ms-2 me-2"></span>}
                            <i class="bi bi-upload"></i> Export
                        </button>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">

                    <div className="row">
                        <div className="col-md-3 mb-md-5 mb-xl-10">
                            <Link to="/users?type=email" 
                            className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10  ${type ==='guest' ? 'bg-secondary' : 'bg-white'}`}
                            >
                                <div className="card-header pt-5">
                                    <div className="card-title d-flex flex-column">
                                        <div className="d-flex align-items-center">
                                            
                                            <span className="fs-2hx fw-bold text-gray-6000 me-2 lh-1 ls-n2">{counts?.guest}</span>
                                        </div>
                                        <span className="text-gray opacity-75 pt-1 fw-semibold fs-4">Guest Signin</span>
                                    </div>
                                </div>
                                <div className="card-body d-flex align-items-end pt-0">
                                    <img src={guest_user} className="w-50px" alt="img" /> 
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3 mb-md-5 mb-xl-10">
                            <Link to="/users?type=google" 
                            className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10  ${type ==='google' ? 'bg-secondary' : 'bg-white'}`}
                            >
                                <div className="card-header pt-5">
                                    <div className="card-title d-flex flex-column">
                                        <div className="d-flex align-items-center">
                                            
                                            <span className="fs-2hx fw-bold text-gray-6000 me-2 lh-1 ls-n2">{counts?.google}</span>
                                        </div>
                                        <span className="text-gray opacity-75 pt-1 fw-semibold fs-4">Google Signin</span>
                                    </div>
                                </div>
                                <div className="card-body d-flex align-items-end pt-0">
                                    <img src={google} className="w-50px" alt="img" /> 
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3 mb-md-5 mb-xl-10">
                            <Link  to="/users?type=apple" 
                            className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10  ${type ==='apple' ? 'bg-secondary' : 'bg-white'}`}
                            >
                                <div className="card-header pt-5">
                                    <div className="card-title d-flex flex-column">
                                        <div className="d-flex align-items-center">
                                            
                                            <span className="fs-2hx fw-bold text-gray-6000 me-2 lh-1 ls-n2">{counts?.apple}</span>
                                        </div>
                                        <span className="text-gray opacity-75 pt-1 fw-semibold fs-4">Apple Signin</span>
                                    </div>
                                </div>
                                <div className="card-body d-flex align-items-end pt-0">
                                    <img src={apple} className="w-50px" alt="img" /> 
                                </div>
                            </Link>
                        </div>
                        <div className="col-md-3 mb-md-5 mb-xl-10">
                            <Link  to="/users?type=email" 
                            className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-100 mb-5 mb-xl-10  ${type ==='email' ? 'bg-secondary' : 'bg-white'}`}
                            >
                                <div className="card-header pt-5">
                                    <div className="card-title d-flex flex-column">
                                        <div className="d-flex align-items-center">
                                            
                                            <span className="fs-2hx fw-bold text-gray-6000 me-2 lh-1 ls-n2">{counts?.email}</span>
                                        </div>
                                        <span className="text-gray opacity-75 pt-1 fw-semibold fs-4">Email Signin</span>
                                    </div>
                                </div>
                                <div className="card-body d-flex align-items-end pt-0">
                                    <img src={email_user} className="w-50px" alt="img" /> 
                                </div>
                            </Link>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-users-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder="Search User name, useranme.." />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                maxDate={new Date()}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{('clear')}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div id="kt_users_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>Image</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Status</th>
                                                <th>Created Date</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {users.length > 0 ? users.map((cat, index) => (
                                                <tr key={index}>
                                                    <td> <img src={cat.picture} alt="logo" className='w-50px h-50px rounded-circle' /> </td>
                                                    <td> {cat.name} </td>
                                                    <td>{cat.email}</td>
                                                    <td>{cat.phone}</td>
                                                    <td>
                                                        <div className="form-check form-switch mt-2">
                                                                <input className="form-check-input" type="checkbox" name="is_delivery" id="flexSwitchCheckChecked" checked={cat.status}  
                                                                onClick={() => updateStatus(cat._id)}/>
                                                        </div>
                                                        <button className="p-0 btn btn-transparent">
                                                            <span className={`badge ${cat.status  ? 'badge-light-success' : 'badge-light-danger'}`} onClick={() => updateStatus(cat._id)} >
                                                                {cat.status  ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </button>
                                                    </td>
                                                    <td>{formatDate(cat.createdAt,'DD MMM YYYY, hh:mm A')}</td>
                                                    <td className="mt-2">
                                                        <Link to={`/users/${cat._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-eye-fill fs-6"></i>
                                                        </Link>
                                                        { selectStoredPermissions().includes('delete-customers') &&
                                                            <button  onClick={() => delData(cat._id)} className="btn btn-sm h-30px btn-light-primary">
                                                                <i className="bi bi-trash-fill fs-6"></i>
                                                            </button>
                                                        }
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> 
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center"  />
                                    )}
                                    <span>Total Records: {pagination?.total_records}</span>


                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
